import {
  GET_PRODUCT_FETCH,
  GET_PRODUCT_REJECTED,
  GET_PRODUCT_SUCCESS,
  GET_PRODUCT_CLEAR,
  GET_PROJECT_FETCH,
  GET_PROJECT_SUCCESS,
  GET_PROJECT_REJECTED,
} from "src/Constants";

const initialState = {
  products: {
    data: [],
    isLoading: false,
    isRejected: false,
  },
  projects: { data: [], isLoading: false, isError: false },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_PROJECT_FETCH:
      return {
        ...state,
        projects: { isLoading: true, isError: false },
      };
    case GET_PROJECT_SUCCESS:
      return {
        ...state,
        projects: {
          data: action.payload,
          isLoading: false,
          isError: false,
        },
      };
    case GET_PROJECT_REJECTED:
      return {
        ...state,
        projects: { isLoading: false, isError: true },
      };
    case GET_PRODUCT_FETCH:
      return {
        ...state,
        products: {
          isLoading: true,
          isRejected: false,
        },
      };

    case GET_PRODUCT_SUCCESS:
      return {
        ...state,
        products: {
          data: action.payload,
          isLoading: false,
          isRejected: false,
        },
      };

    case GET_PRODUCT_REJECTED:
      return {
        ...state,
        products: {
          isLoading: false,
          isRejected: true,
        },
      };
    case GET_PRODUCT_CLEAR:
      return {
        ...state,
        products: {
          isLoading: false,
          isRejected: false,
          data: [],
        },
      };
    default:
      return state;
  }
};
